// ===== 1. Imports =====
import React from "react";
import { Loader2 } from "lucide-react";

// ===== 2. Componente Principal =====
export default function LoadingScreen({ projectName }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg)",
        color: "var(--fg)",
      }}
    >
      <div
        className="card"
        style={{
          padding: "32px 40px",
          border: "1px solid var(--ring)",
          borderRadius: 16,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
          transform: "translateY(-15%)",
        }}
      >
        <div style={{ fontSize: 16, fontWeight: 600 }}>{projectName}</div>
        <Loader2 size={32} className="spin" style={{ color: "var(--muted)" }} />
      </div>
    </div>
  );
}
